import cookies from './cookies';
import qs from 'qs';

const COOKIE_KEY = 'bn.vst';
const COOKIE_KEY_SESSION = 'bn.vst-s';

export const IS_RETURNING = 'a';
export const HAS_LOGGED_IN = 'b';
export const HAS_BOLIGAGENT = 'c';
export const HAS_SUBSCRIPTION = 'd';

function parseCookie() {
  try {
    if (!cookies.getItem(COOKIE_KEY)) {
      throw new Error('Cookie not initialized');
    }
    return qs.parse(cookies.getItem(COOKIE_KEY));
  } catch (err) {
    cookies.setItem(COOKIE_KEY_SESSION, '1', null, '/');
    return {
      [IS_RETURNING]: '1'
    };
  }
}

function saveCookie() {
  const data = qs.stringify(cookieData);
  cookies.setItem(COOKIE_KEY, data, 365 * 24 * 60 * 60, '/');
}

const firstSession = __CLIENT__ && cookies.getItem(COOKIE_KEY_SESSION);
const cookieData = __CLIENT__ && parseCookie();
if (__CLIENT__) {
  saveCookie();
}

export default function visitor(key, value) {
  if (!__CLIENT__) {
    return false;
  }
  if (key) {
    if (typeof value !== 'undefined') {
      cookieData[key] = value ? '1' : '';
      saveCookie();
    }
    if (key === IS_RETURNING && firstSession) {
      return false;
    }
    return Boolean(cookieData[key]);
  }
  return false;
}
